/**
 * Enum for notification types.
 */
export enum NotificationType {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export enum GenericValues {
  CURRENT_LOCATION = "Current location",
}

export enum DefaultSearchSuggestion {
  CARPENTER = "carpenter",
  APARTMENTS = "apartments",
  FURNITURE = "furniture",
  BICYCLES = "bicycles",
  VINTAGE = "vintage",
}

export enum Category {
  ELECTRONICS = "Electronics",
  APPAREL = "Apparel",
  VEHICLES = "Vehicles",
  FURNITURE = "Furniture",
  HOME_APPLIANCES = "Home Appliances",
  FOOTWEAR_ACCESSORIES = "Footwear Accessories",
  SPORTING_GOODS = "Sporting Goods",
  BOOKS_STUDY_MATERIALS = "Books Study Materials",
}

export enum InfoIconKey {
  USER_PREFERENCES_SECTION = "user_preferences_section",
  NINE_FINDS_RADIUS = "nine_finds_radius",
  TOOLTIP_TOGGLE = "tooltip_toggle",
  NINE_LOCAL_FINDS = "nine_local_finds",
  ANNOUNCEMENTS_SECTION = "announcements_section",
  VALUE_PROPOSITION = "value_proposition",
  COMMUNITY_FEEDBACK = "community_feedback",
  SUGGESTIONS_SECTION = "suggestions_section",
  VALUE_PROPOSITION_1 = "value_proposition_1",
  VALUE_PROPOSITION_2 = "value_proposition_2",
  VALUE_PROPOSITION_3 = "value_proposition_3",
}

export enum KnowMoreSection {
  BUY_SELL = "buy_sell",
  SERVICE_PROVIDERS = "service_providers",
  COMMUNITY_NEEDS = "community_needs",
  SMART_LISTINGS = "smart_listings",
}

// Registry of all swallow tips in the app.
// Add one entry per tip — the string value is used as the localStorage key.
export enum TipId {
  USER_LISTINGS_FILTER_TAGS = "tip_user_listings_filter_tags",
}

// What the search bar is currently searching for.
// Add a new scope here to surface it as a tab in SearchScopeTabs.
export enum SearchScope {
  LISTINGS = "listings",
  PEOPLE = "people",
  BUSINESSES = "businesses",
  // Businesses grouped under a shared collection id (looked up by that id).
  COLLECTIONS = "collections",
}
